import { useFieldValue } from 'vee-validate';
import { isNil } from 'lodash-es';
import { useI18n } from 'vue-i18n';
import { computed, ref, type Ref } from 'vue';

export default (fieldName: string, nullText?: string) => {
  let value = useFieldValue(fieldName);

  const { t } = useI18n();
  const valueText = computed(() => {
    if (!isNil(value.value) || !nullText) {
      return value.value ? t('inputSwitch.active') : t('inputSwitch.inactive');
    } else {
      return nullText;
    }
  });

  return {
    valueText,
  };
};
